'use client'

import { STORAGE_KEY, PREFERENCES_EVENT } from './CookieBanner'

export default function CookiePreferencesLink() {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (typeof window !== 'undefined') {
      localStorage.removeItem(STORAGE_KEY)
      window.dispatchEvent(new Event(PREFERENCES_EVENT))
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="hover:text-[#ffa300] transition-colors bg-transparent border-none cursor-pointer text-sm font-medium text-zinc-400 py-2 font-inherit"
    >
      Preferências de cookies
    </button>
  )
}
